import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import truckImage from "../static/images/image1.png";
import logo from '../../logos/storage-sprint.png';
import { Helmet } from 'react-helmet';


const RegistrationSelectionPage = () => {
  const navigate = useNavigate();
  const [logoLoaded, setLogoLoaded] = useState(false);


  const handleNavigate = (accountType) => {
    navigate(`/registration/${accountType}`);
  };

  const handleLoginClick = () => {
    navigate("/login");
  }

  return (
    <>
      <Helmet>
        <title>Select Account Type - Storage Sprint</title>
      </Helmet>

      <div className="min-h-screen flex flex-col md:flex-row bg-gradient-to-br bg-white">
        {/* Left Side */}
        <div className="flex-1 flex flex-col items-center justify-center bg-yellow-500 text-white p-8">
          <img
            className="w-32 h-auto mb-6"
            src={logo}
            alt="Storage Sprint Logo"
          />
          <img
            className="w-full max-w-md h-auto object-contain hidden md:block"
            src={truckImage}
            alt="Storage Sprint Truck"
          />
          <h2 className="text-2xl md:text-3xl font-bold mt-6 text-center">
            SCHEDULE YOUR DELIVERY NOW!
          </h2>
        </div>

        {/* Right Side */}
        <div className="flex-1 flex flex-col items-center justify-center p-8">
          <div className="w-full max-w-md bg-white p-6 rounded-xl shadow-lg">
            

            <div className="text-center mb-6">
              <h3 className="text-lg font-semibold text-gray-800">
                SELECT ACCOUNT TYPE
              </h3>
            </div>

            <div className="space-y-4">
              <button
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                onClick={() => handleNavigate("personal")}
              >
                Customer Account
              </button>
              <button
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                onClick={() => handleNavigate("business")}
              >
                Driver Account
              </button>
            </div>

            <p className="text-sm text-gray-600 mt-4 text-center">
              Already have an account?{" "}
              <span
                className="text-yellow-600 font-semibold cursor-pointer hover:underline"
                onClick={handleLoginClick}
              >
                Login
              </span>
            </p>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default RegistrationSelectionPage;
